// Error Boundary component with Application Insights integration
import React from 'react';
import { trackException } from '../../config/appInsights';

class AppInsightsErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Track the error in Application Insights
    trackException(error, {
      component: 'ErrorBoundary',
      errorInfo: JSON.stringify(errorInfo),
      stackTrace: error.stack,
      componentStack: errorInfo.componentStack,
      timestamp: new Date().toISOString()
    });
    
    // Update state with error details
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // Log to console for development
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Custom error UI
      return (
        <div className="error-boundary-container" style={{
          padding: '2rem',
          textAlign: 'center',
          backgroundColor: '#f8f9fa',
          minHeight: '50vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <h2 style={{ color: '#dc3545', marginBottom: '1rem' }}>
            Oops! Something went wrong
          </h2>
          <p style={{ color: '#6c757d', marginBottom: '1.5rem' }}>
            We're sorry, but something unexpected happened. The error has been logged and we'll look into it.
          </p>
          
          <button
            className="btn btn-primary"
            onClick={() => window.location.reload()}
            style={{ marginRight: '1rem' }}
          >
            Reload Page
          </button>
          
          <button
            className="btn btn-secondary"
            onClick={() => window.history.back()}
          >
            Go Back
          </button>
          
          {process.env.NODE_ENV === 'development' && (
            <details style={{ marginTop: '2rem', textAlign: 'left', maxWidth: '600px' }}>
              <summary style={{ cursor: 'pointer', marginBottom: '1rem' }}>
                Error Details (Development Mode)
              </summary>
              <pre style={{ 
                backgroundColor: '#fff', 
                padding: '1rem', 
                border: '1px solid #dee2e6',
                borderRadius: '0.25rem',
                fontSize: '0.875rem',
                overflow: 'auto'
              }}>
                {this.state.error && this.state.error.toString()}
                <br />
                {this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppInsightsErrorBoundary;